import WarningIcon from "img/checkout/icons/warning.svg?inline";
import React from "react";
import { Button } from "web/react/emo/button";
import { Modal } from "web/react/emo/modal";
import styles from "./error-modal.module.css";

interface ErrorModalProps {
    title: string;
    description: string;
    isOpen: boolean;
    onClose: () => void;
    buttonCTAText: string;
    buttonCTA?: () => void;
}

function ErrorModal({
    title,
    description,
    isOpen,
    onClose,
    buttonCTAText,
    buttonCTA,
}: ErrorModalProps): React.ReactElement {
    return (
        <Modal isOpen={isOpen} onClose={onClose} className={styles.modal}>
            <div className={styles.overlayContainer}>
                <div className={styles.inline}>
                    <span className={styles.title}>{title}</span>
                    <WarningIcon />
                </div>
                <div className={styles.description}>
                    <p>{description}</p>
                </div>
                <Button title={buttonCTAText} width="full" onClick={buttonCTA}></Button>
            </div>
        </Modal>
    );
}

export default ErrorModal;
